import Request from './request'

async function getReturnableView(id) {//根据订单ID获取可退商品
    return Request('get', "api/return-orders/get-returnable-view/" + id);
}

export default {
    getReturnableView,
};
